export function formatDuration(seconds, t) {
  seconds = Math.floor(seconds); // remove decimal if any

  const days = Math.floor(seconds / (24 * 3600));
  seconds %= 24 * 3600;

  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  const parts = [];
  if (days > 0) parts.push(`${days} ${t("DayDuration")}`);
  if (hours > 0) parts.push(`${hours} ${t("Hour")}`);
  if (minutes > 0) parts.push(`${minutes} ${t("Minit")}`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs} ${t("Second")}`);

  return parts.join(" ");
}

export function getUtcDateWithLocalMidnight(date) {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.floor(offsetMinutes / 60);
  const offsetMins = offsetMinutes % 60;

  return new Date(Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    offsetHours,
    offsetMins,
    0
  ));
}
